/**
 * @fileOverview
 * 用于封装操作 store 的接口，和 store 进行通信，接口暴露给其他逻辑层使用.
 * TODO: 将其他逻辑层里直接操作 project 的 store 方法抽离到本类中
 */

import { message } from 'antd';
import store from '../reducers';
import ProjectAction from '../reducers/project/action';
import ProjectApi from '../services/api/project';
import MscratchService from '../services/mscratch';
import ProjectLocal from '../services/project/project.local';
import CONSTANT from '../constant';
import History from '../util/history';
import { genId } from '../util';

class ProjectModel {
    constructor() {

    }

    createNewProject (opt_projectType) {
        const {project, intlr} = store.getState();
        let initProjectName = ProjectApi.getNewProjectName(intlr.messages['FILENAME.EMPTY'], project.projects);
        const initData = {
            filePath: null,
            file: null,
            id: '',
            projectId: '',
            commitId: '',
            name: initProjectName,
            localName: '',
            projectType: opt_projectType || '',
            projectStatus: '',
            isReName: false,
            createdAt: '',
            downloadStatus: {
                err: null,
                percent: 0
            },
            saveStatus: '',
            searchText: '',
            isSelfProject: true,
            isShare: false,
            showLoadingPage: false // 新建项目不显示loading页
        };
        store.dispatch(ProjectAction.saved({
            file: null,
            confirmSaveType: null,
            ...initData
        }));
        this.setProjectPlatformType();
    }

    reName (newName) {
        store.dispatch(ProjectAction.saved({
            name: newName,
        }));
    }

    /* 重置项目各状态，例如projectId, 保存状态等 */
    resetProjectState() {
        store.dispatch(ProjectAction.saved({
            projectId: '',
            isSelfProject: true,
            isShare: false,
            commitId: '',
            projectStatus: '',
            isReName: false,
            createdAt: '',
            saveStatus: '',
            isConfirmName: false,
            projectType: ''
        }));
    }

    initName(projects) {
        const { intlr, project } = store.getState();
        const { messages } = intlr;
        const { isConfirmName, projectId, projectType, name } = project;
        if (projectId || projectType === 'example' || projectType === 'local') return;
        const defaultName = isConfirmName ? name : messages['FILENAME.EMPTY'];
        const initName = ProjectApi.getNewProjectName(defaultName, projects);
        store.dispatch(ProjectAction.saved({
            name: initName
        }));
    }

    setSaved(state) {
        let content = state === false ? 'null' : '';
        store.dispatch(ProjectAction.updatePreProject(content));
    }

    isSaved() {
        let preData = store.getState().project.preProjectData;
        let nowData = MscratchService.getProjectJsonString();
        return preData === nowData;
    }

    setLoaded(state) {
        store.dispatch(ProjectAction.updateProjectLoadedState(state));
    }

    checkProjectChanged() {
        store.dispatch(ProjectAction.checkProjectChangeState(store));
    }

    async addProject(type, args) {
        const { project, account } = store.getState();
        const { projects } = project;
        const userId = String(account.data.uid || 'null');
        let _projects = projects;
        const _id = args.id || genId();
        const newProject = {
            id: _id,
            userId,
            projectId: '',
            commitId: '',
            createdAt: Date.parse(new Date()) / 1000,
            projectName: '',
            localName: _id,
            syncStatus: CONSTANT.PROJECT_STATUS['WILL_UPLOAD_ALL'],
            isDeleted: false,
            isShare: false,
            coverImage: '',
            ...args
        };
        _projects.push(newProject);

        store.dispatch({
            type,
            payload: {
                projects: _projects
            }
        });
        let _localList = await ProjectLocal.get();
        _localList[userId] = _projects;
        ProjectLocal.set(_localList);
        return newProject;
    }

    async updateProject(type, id, args) {
        const { project, account } = store.getState();
        const { projects } = project;
        const userId = String(account.data.uid || 'null');

        let _projects = projects;
        _projects = _projects.map((p) => p.id === id ? { ...p, ...args } : p);

        store.dispatch({
            type,
            payload: {
                projects: _projects
            }
        });
        let _localList = await ProjectLocal.get();
        _localList[userId] = _projects;
        ProjectLocal.set(_localList);
    }

    /**
     *
     * @param {string | ArrayBuffer} file 存储到 project 的 store 中，
     * 主要用于保存弹窗相关逻辑使用
     * @param {string} name 项目名
     * @type {string} type 项目类型
     */
    setCurrentFileCacheName(file, name, type) {
        store.dispatch(ProjectAction.saved({
            file: file,
            cacheName: name,
            projectType: type
        }));
    }

    /**
     *
     * @param {string | ArrayBuffer} file 存储到 project 的 store 中，
     * 主要用于保存弹窗相关逻辑使用
     */
    setCurrentFile(file) {
        store.dispatch(ProjectAction.saved({
            file: file
        }));
    }

    setProjectSaveStatus(status) {
        let saveStatus = CONSTANT.PROJECT_SAVE_STATUS[status];
        store.dispatch(ProjectAction.saved({
            saveStatus
        }));
        if (status === 'SUCCESS' || status === 'FAILURE') {
            setTimeout(() => {
                if (store.getState().project.saveStatus === 'DOING') return;
                store.dispatch(ProjectAction.saved({
                    saveStatus: ''
                }));
            }, 3000);
        }
    }

    gotoRoot() {
        History.replace('/');
    }

    setProSelfAndShare(isSelfProject, isShare) {
        let obj = {
            isSelfProject,
            isShare,
        };
        store.dispatch(ProjectAction.saved(obj));
    }

    setProSelfAndShareOnConfirm(project) {
        const { projectType, projectId, projects } = project;

        if (projectType === CONSTANT.PROJECT_TYPE.EXAMPLE || projectType === CONSTANT.PROJECT_TYPE.LOCAL) {
            this.setProSelfAndShare(true, false);
        } else {
            const isSelfPro = ProjectApi.isSelfProject(projectId);
            const isShare = ProjectApi.hasShared(projects, projectId);
            this.setProSelfAndShare(isSelfPro, isShare);
        }
    }

    setLoadingPageState(status) {
        store.dispatch(ProjectAction.saved({
            showLoadingPage: status
        }));
    }

    /**
     * 用于选择对应的保存操作并返回对应的数据
     */
    selectSaveOperation() {
        return {
            'new': function(obj) { // 新建项目或者另存为项目
                console.log('new project');
                const { _id, createdAt, name, projectData, projects } = obj;
                const id = _id;
                const newProject = {
                    id,
                    createdAt,
                    projectName: name,
                    localName: id,
                    syncStatus: CONSTANT.PROJECT_STATUS['WILL_UPLOAD_ALL'],
                    data: projectData
                };
                const projectInfos = newProject;
                projects.push(newProject);

                return {
                    id,
                    projectId: '',
                    projectInfo: projectInfos,
                    projects
                };
            },
            'update': function(obj) { // 修改项目
                console.log('update project');
                const { id, createdAt, projectInfo, name, projectId, projectData, projects } = obj;
                projects.map(p => p.id === projectId ? {
                    ...p,
                    createdAt,
                    projectName: name,
                    syncStatus: CONSTANT.PROJECT_STATUS['WILL_UPLOAD_FILE'],
                    data: projectData
                } : p);

                let projectInfos = {
                    ...projectInfo,
                    id,
                    projectId,
                    createdAt,
                    projectName: name,
                    localName: name,
                    data: projectData
                };

                return {
                    id,
                    projectId,
                    projectInfo: projectInfos,
                    projects
                };
            },
            'adapt': function(obj) { // 改编项目
                console.log('adapt project');
                const { _id, createdAt, name, projectId, projectData, projects } = obj;
                const id = _id;
                const newProject = {
                    id,
                    createdAt,
                    projectName: name,
                    localName: id,
                    syncStatus: CONSTANT.PROJECT_STATUS['WILL_UPLOAD_ALL'],
                    data: projectData
                };
                const projectInfos = newProject;
                projects.push(newProject);

                return {
                    id,
                    projectId,
                    projectInfo: projectInfos,
                    projects
                };
            }
        };
    }

    /**
     * 用于设置保存进度
     */
    saveProjectProgress(progress) {
        store.dispatch(ProjectAction.saved({saveProgress: progress}));
    }

    /**
     * 保存异常处理
     */
    saveError() {
        this.setProjectSaveStatus('FAILURE');
        const { messages } = store.getState().intlr;
        message.error(messages['MENU.FILE.UPLOAD.FAIL']);
        this.saveProjectProgress(0);
    }

    /* 设置作品是否为分享到第三方平台的作品 */
    setProjectPlatformType(projectId, projectType) {
        // TODO: 由于时序问题，projectId 由调用处传进来而不是从store中取
        const { project } = store.getState();
        let id = projectId || project.projectid;
        let type = projectType || project.projectType;
        let result = this.getProjectCloudThirdPlatform();
        // 如果是自己的作品，或者示例，则不做隐藏
        if (!id || type === CONSTANT.PROJECT_TYPE.EXAMPLE) {
            result = false;
        }
        if (id && ProjectApi.isSelfProject(id)) {
            result = false;
        }
        store.dispatch(ProjectAction.saved({
            isForThirdPlatform: result
        }));
    }

    setProjectCloudThirdPlatform(isForThirdPlatform) {
        this.cloudThirdPlatform = isForThirdPlatform;
    }

    getProjectCloudThirdPlatform() {
        return this.cloudThirdPlatform;
    }
}

const projectModel = new ProjectModel();
window.projectModel = projectModel;
export default projectModel;